import { useState } from "react";
import { useAuthenticatedApiClient } from "@/hooks/useAuthenticatedApiClient";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";
import { useFinancialApplicationCoreData } from "@/hooks/useFinancialApplicationCoreData";

export const useDisclosures = (financialApplicationId: string) => {
  const { disclosures, refreshCoreData } = useFinancialApplicationCoreData(financialApplicationId);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const apiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const getDisclosure = (disclosureId: string) => {
    return disclosures?.find((d) => d.id === disclosureId);
  };

  const agreeToDisclosure = async (disclosureId: string) => {
    try {
      setLoading(true);
      setError(null);

      await apiClient.agreeToDisclosure(financialApplicationId, disclosureId);

      // Refresh core data to get updated disclosure state
      await refreshCoreData();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to agree to disclosure");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    disclosures,
    agreeToDisclosure,
    getDisclosure,
    loading,
    error,
  };
};
